import cn from "@/util/cn";
import { ReactNode } from "react";
import { toast } from "sonner";

type ToastProps = {
  toastId: string | number;
  title?: ReactNode;
  description: ReactNode;
  variant?: "info" | "error";
};

const Toast = ({ toastId, title, description, variant = "info" }: ToastProps) => (
  <div
    className={cn(
      "flex items-start gap-4 rounded-md border border-sky-500 bg-sky-400 p-4 text-white/90",
      {
        "border-red-600 bg-red-500": variant === "error",
      },
      {
        "border-sky-500 bg-sky-400": variant === "info",
      }
    )}
  >
    <span className="material-icons">{variant === "error" ? "error" : "info"}</span>
    <div className="grid gap-1">
      {title && <h1 className="font-semibold">{title}</h1>}
      {description && <p className="font-medium">{description}</p>}
    </div>
    <button
      className="flex cursor-pointer border-none bg-transparent"
      onClick={() => toast.dismiss(toastId)}
    >
      <span className="material-icons" style={{ fontSize: "20px" }}>
        close
      </span>
    </button>
  </div>
);

export default Toast;
